function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Text } from "../..";
import { formatBigNumber } from "../../../../../src/utils/formatBalance";
import { Flex } from "../Box";
import { Button } from "../Button";
import { Link } from "../Link";
import { ArrowForwardIcon } from "../Svg";
import InputFooterEmailHelper from "./Components/InputFooterEmailHelper";
import { FooterEmail, StyledFooter, StyledList, StyledListItem, StyledSocialLinks, StyledText, StyledToolsContainer } from "./styles";
var MenuItem = function(_param) {
    var // isMobile,
    // isDark,
    // toggleTheme,
    // currentLang,
    // langs,
    // setLang,
    // cakePriceUsd,
    items = _param.items, buyCakeLabel = _param.buyCakeLabel, balance = _param.balance, account = _param.account, tokenPrice = _param.tokenPrice, props = _objectWithoutProperties(_param, [
        "items",
        "buyCakeLabel",
        "balance",
        "account",
        "tokenPrice"
    ]);
    var ref1;
    return /*#__PURE__*/ _jsx(StyledFooter, _objectSpread({
        "data-theme": "dark",
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props, {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsxs(Flex, {
                    // order={[2, null, 1]}
                    order: "1",
                    flexDirection: [
                        "column",
                        null,
                        "column",
                        "row"
                    ],
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    children: [
                        items === null || items === void 0 ? void 0 : items.map(function(item) {
                            var ref;
                            /*#__PURE__*/ return _jsxs(StyledList, {
                                children: [
                                    /*#__PURE__*/ _jsx(StyledListItem, {
                                        children: item.label
                                    }),
                                    (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                        var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
                                        return /*#__PURE__*/ _jsx(StyledListItem, {
                                            children: href ? /*#__PURE__*/ _jsx(Link, {
                                                "data-theme": "dark",
                                                href: href,
                                                target: href !== "#" ? "_blank" : "",
                                                rel: "noreferrer noopener",
                                                bold: false,
                                                color: isHighlighted ? "#ED863B" : "white",
                                                fontWeight: 600,
                                                children: label
                                            }) : /*#__PURE__*/ _jsx(StyledText, {
                                                children: label
                                            })
                                        }, label);
                                    })
                                ]
                            }, item.label);
                        }),
                        /*#__PURE__*/ _jsx(Flex, {
                            bg: "white",
                            p: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "8px",
                            order: [
                                1,
                                null,
                                null
                            ],
                            mb: "24px",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/images/we-dex.png",
                                alt: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(StyledToolsContainer, {
                    "data-theme": "dark",
                    order: [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "column",
                        "row"
                    ],
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(Flex, {
                            order: [
                                2,
                                null,
                                2,
                                1
                            ],
                            alignItems: "center",
                            children: /*#__PURE__*/ _jsx(StyledSocialLinks, {
                                order: [
                                    2
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            order: [
                                1,
                                null,
                                1,
                                2
                            ],
                            mb: [
                                "24px",
                                null,
                                "24px",
                                "0"
                            ],
                            justifyContent: "space-between",
                            flexDirection: [
                                "column",
                                null,
                                "column",
                                "row"
                            ],
                            alignItems: [
                                "flex-start",
                                null,
                                "flex-start",
                                "center"
                            ],
                            position: "relative",
                            children: [
                                /*#__PURE__*/ _jsx(FooterEmail, {
                                    children: /*#__PURE__*/ _jsx(InputFooterEmailHelper, {})
                                }),
                                account && (balance === null || balance === void 0 ? void 0 : balance.fetchStatus) === "FETCHED" && /*#__PURE__*/ _jsxs(Flex, {
                                    mr: [
                                        null,
                                        null,
                                        null,
                                        "80px"
                                    ],
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mb: [
                                        "24px",
                                        null,
                                        "24px",
                                        "0"
                                    ],
                                    children: [
                                        /*#__PURE__*/ _jsx(Flex, {
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            mr: "12px",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/logo.png",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            as: "p",
                                            fontWeight: 500,
                                            color: "#fff",
                                            children: [
                                                "$",
                                                (ref1 = +formatBigNumber(balance === null || balance === void 0 ? void 0 : balance.balance, 3) * tokenPrice) === null || ref1 === void 0 ? void 0 : ref1.toFixed(3)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    // data-theme="light"
                                    as: "a",
                                    href: "#",
                                    // target="_blank"
                                    // scale="sm"
                                    endIcon: /*#__PURE__*/ _jsx(ArrowForwardIcon, {
                                        color: "white"
                                    }),
                                    variant: "primary",
                                    children: buyCakeLabel
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
